var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayWithCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453 365.1H95.1C86.2 365.1 79 357.9 79 349V115.5C79 106.6 86.2 99.4 95.1 99.4H452.8C461.7 99.4 468.9 106.6 468.9 115.5V348.9C469.1 357.8 461.9 365.1 453 365.1Z",
    fill: "#46C5E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 328.2C115 331.4 117.6 333.9 120.7 333.9H147.4C150.6 333.9 153.1 331.3 153.1 328.2C153.1 325 150.5 322.5 147.4 322.5H120.7C117.5 322.3 115 324.9 115 328.2ZM161 328.2C161 331.4 163.6 333.9 166.7 333.9H211.7C214.9 333.9 217.4 331.3 217.4 328.2C217.4 325 214.8 322.5 211.7 322.5H166.7C163.6 322.3 161 324.9 161 328.2ZM225.5 328.2C225.5 331.4 228.1 333.9 231.2 333.9H312.7C315.9 333.9 318.4 331.3 318.4 328.2C318.4 325 315.8 322.5 312.7 322.5H231.2C228.1 322.3 225.5 324.9 225.5 328.2Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417 412.5H59.2C50.3 412.5 43.1 405.3 43.1 396.4V162.9C43.1 154 50.3 146.8 59.2 146.8H416.9C425.8 146.8 433 154 433 162.9V396.3C433.1 405.2 425.9 412.5 417 412.5Z",
    fill: "#66CDF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 201.8H433.1V243.9H43.1V201.8Z",
    fill: "#242456"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 375.6C79 378.8 81.6 381.3 84.7 381.3H111.4C114.6 381.3 117.1 378.7 117.1 375.6C117.1 372.4 114.5 369.9 111.4 369.9H84.7C81.5 369.7 79 372.3 79 375.6ZM125.1 375.6C125.1 378.8 127.7 381.3 130.8 381.3H175.8C179 381.3 181.5 378.7 181.5 375.6C181.5 372.4 178.9 369.9 175.8 369.9H130.8C127.7 369.7 125.1 372.3 125.1 375.6ZM189.5 375.6C189.5 378.8 192.1 381.3 195.2 381.3H276.7C279.9 381.3 282.4 378.7 282.4 375.6C282.4 372.4 279.8 369.9 276.7 369.9H195.2C192.1 369.7 189.5 372.3 189.5 375.6ZM79 321.6H242.4V353H79V321.6Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayWithCard);
export default __webpack_public_path__ + "static/media/pay-with-card.90791151e9c1a9d74299f767de507fe5.svg";
export { ForwardRef as ReactComponent };